const P = 'sd2_'

export const storage = {
  accessToken: () => localStorage.getItem(`${P}access_token`),
  setAccessToken: (t: string) => localStorage.setItem(`${P}access_token`, t),
  clearAccessToken: () => localStorage.removeItem(`${P}access_token`),

  refreshToken: () => localStorage.getItem(`${P}refresh_token`),
  setRefreshToken: (t: string) => localStorage.setItem(`${P}refresh_token`, t),
  clearRefreshToken: () => localStorage.removeItem(`${P}refresh_token`),

  userJson: () => localStorage.getItem(`${P}user`),
  setUserJson: (j: string) => localStorage.setItem(`${P}user`, j),
  clearUser: () => localStorage.removeItem(`${P}user`),

  clearSession() {
    this.clearAccessToken()
    this.clearRefreshToken()
    this.clearUser()
    try {
      localStorage.removeItem('sd2_workspace_my_permissions')
    } catch {
      /* ignore */
    }
  },
}
